module.exports = __webpack_public_path__ + "static/media/image_organizers_mobile.89b9f541.png";